import Abstract from "../../../abstract-view/abstract.js";

import {
  createElement
} from "../../../render/render.js";

import {
  RESPONSIVE_FILTER_CLOSE as RESPONSIVE_FILTER_CLOSE_LEXICON
} from "../lexicon.js";

const createResponsiveFilterTemplate = () => {
  return (
    `<section class="responsive-filter">
      <div class="responsive-filter__wrapper">
        <div class="responsive-filter-heading-wrapper">
          <div class="container">
            <div class="responsive-filter-heading-container">
              <h2 class="responsive-filter-heading">Фильтры</h2>
              <button class="responsive-filter__close-button">
                <span class="visually-hidden">${RESPONSIVE_FILTER_CLOSE_LEXICON}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="responsive-filter-container">
          </div>
        </div>
      </div>
    </section>`
  );
};

export default class ResponsiveFilter extends Abstract {
  constructor() {
    super();

    this._containerElement = null;
    this._wrapperElement = null;
    this._closeButtonElement = null;
    this._headingContainerElement = null;

    this._closeButtonClickHandler = this._closeButtonClickHandler.bind(this);
    this._touchstartHandler = this._touchstartHandler.bind(this);
    this._touchendHandler = this._touchendHandler.bind(this);
    this._touchcancelHandler = this._touchcancelHandler.bind(this);
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  getContainerElement() {
    if (!this._containerElement) {
      this._containerElement = this._element.querySelector(`.responsive-filter-container`);
    }

    return this._containerElement;
  }

  getHeadingContainerElement() {
    if (!this._headingContainerElement) {
      this._headingContainerElement = this._element.querySelector(`.responsive-filter-heading-container`);
    }

    return this._headingContainerElement;
  }

  getWrapper() {
    if (!this._wrapperElement) {
      this._wrapperElement = this._element.querySelector(`.responsive-filter__wrapper`);
    }

    return this._wrapperElement;
  }

  getCloseButton() {
    if (!this._closeButtonElement) {
      this._closeButtonElement = this._element.querySelector(`.responsive-filter__close-button`);
    }

    return this._closeButtonElement;
  }

  getCloseButtonWrapper() {
    return this.getCloseButton().parentElement;
  }

  setZIndex(value) {
    this.getElement().style.zIndex = value;
  }

  setCloseButtonClickHandler(callback) {
    this._callback.closeButtonClick = callback;
    this.getCloseButton().addEventListener(`click`, this._closeButtonClickHandler);
  }

  setTouchstartHandler(callback) {
    this._callback.touchstart = callback;
    this._element.addEventListener(`touchstart`, this._touchstartHandler, {
      passive: true
    });
  }

  setTouchendHandler(callback) {
    this._callback.touchend = callback;
    this._element.addEventListener(`touchend`, this._touchendHandler);
  }

  setTouchcancelHandler(callback) {
    this._callback.touchcancel = callback;
    this._element.addEventListener(`touchcancel`, this._touchcancelHandler);
  }

  _touchstartHandler(evt) {
    this._callback.touchstart(evt);
  }

  _touchendHandler(evt) {
    this._callback.touchend(evt);
  }

  _touchcancelHandler() {
    this._callback.touchcancel();
  }

  _getTemplate() {
    return createResponsiveFilterTemplate();
  }

  _closeButtonClickHandler() {
    this._callback.closeButtonClick();
  }
}
